import type { OrgMembership } from './types'

export type YieldUnit = 'lb_ac' | 'kg_ha'

// Same factor as the server (core/units.ts): one lb/ac in kg/ha.
const KG_HA_PER_LB_AC = 0.45359237 / (4046.8564224 / 10_000)

/** The unit the org wants yields shown in: pounds per acre for imperial, kilograms per hectare for metric. */
export const orgYieldUnit = (org: Pick<OrgMembership, 'unitSystem'> | null | undefined): YieldUnit => (org?.unitSystem === 'METRIC' ? 'kg_ha' : 'lb_ac')

export const yieldUnitLabel = (unit: YieldUnit) => (unit === 'lb_ac' ? 'lb/ac' : 'kg/ha')

/** A number for an input box: no trailing zeros, at most 1 decimal. */
export function yieldInputValue(kgPerHa: number, unit: YieldUnit) {
  return String(Number((unit === 'lb_ac' ? kgPerHa / KG_HA_PER_LB_AC : kgPerHa).toFixed(1)))
}
